import { Component, EventEmitter, Input, Output, TemplateRef } from '@angular/core';
import { Holiday } from '@app/core/interfaces/c5/holiday';
import { PortalEvent, SingleDayEvent } from '@app/shared/models/portal-event';

@Component({
  selector: 'portal-agenda',
  templateUrl: './agenda.component.html',
  styleUrls: ['./agenda.component.scss'],
  standalone: false,
})
export class AgendaComponent {
  @Output()
  onCreateEvent: EventEmitter<void> = new EventEmitter();

  @Output()
  onEditEvent: EventEmitter<PortalEvent<any>> = new EventEmitter();

  @Output()
  onRemoveEvent: EventEmitter<PortalEvent<any>> = new EventEmitter();

  @Input()
  actions: TemplateRef<any>;

  @Input()
  events: SingleDayEvent<Holiday>[];

  constructor() {}

  create() {
    this.onCreateEvent.emit();
  }

  edit(event: SingleDayEvent<Holiday>) {
    this.onEditEvent.emit(event);
  }

  remove(event: SingleDayEvent<Holiday>) {
    this.onRemoveEvent.emit(event);
  }
}
